var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.857 9.86a6.13 6.13 0 011.796-4.204 6.111 6.111 0 014.345-1.8 6.096 6.096 0 014.341 1.801c.177.177.343.364.497.56l-1.075.84a.143.143 0 00.053.252l3.138.768a.143.143 0 00.177-.138l.014-3.23a.142.142 0 00-.23-.113l-1.008.788A7.498 7.498 0 002.5 9.854a.143.143 0 00.143.146h1.071a.143.143 0 00.143-.14zm13.5.14h-1.071a.143.143 0 00-.143.14 6.11 6.11 0 01-1.796 4.204 6.115 6.115 0 01-4.345 1.799 6.111 6.111 0 01-4.84-2.36l1.075-.84a.143.143 0 00-.053-.252l-3.138-.768a.143.143 0 00-.176.138l-.013 3.232c0 .12.138.187.23.112l1.008-.787A7.499 7.499 0 0017.5 10.147a.143.143 0 00-.143-.147z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableReset);
export default __webpack_public_path__ + "static/assets/table-reset.c7cd7fcd.svg";
export { ForwardRef as ReactComponent };